import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Container, Message } from 'semantic-ui-react';
import Txt from '../../../inputs/textInput.js';
import { ContextualMenu, hideWhenClickAwayOrResize, showHideMenu } from '../../../shared/contextualMenu/content';
import { updateWaitingAreaSearch, updateSelectedVideoCallRoomId } from '../../../../actions/waitingArea';
import { sortWaitingAreaRooms } from '../../../../businessLogic/sorter.js';
import { getMinuteDiff, getDOBFormat } from '../../../helpers/date';
import { clone } from '../../../../reducers/helper';
import CenterPanelShared from './centerPanelShared';
import { Media } from '../../../../mediaSetting';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ViewOneWaitingAreaCenterPanelGroupConsultation(props) {
  const asOfNow = useSelector((state) => state.sharedReducer.asOfNow);
  const isCurrentUserInCall = useSelector((state) => state.usersReducer.isInCall);
  const isCurrentUserInGCCall = useSelector((state) => state.usersReducer.isInGCCall);
  const waitingAreaClosingMessageThresholdMinutes = useSelector(
    (state) => state.usersReducer.userProfile.waitingAreaClosingMessageThresholdMinutes
  );
  const isGroupConsultationFeatureEnabled = useSelector(
    (state) => state.usersReducer.isGroupConsultationFeatureEnabled
  );

  const dispatch = useDispatch();
  const [id, setId] = useState(props.id);
  const [waitingAreaRoomsFiltered, setWaitingAreaRoomsFiltered] = useState(
    props.waitingAreaRoomsFiltered.slice().sort(sortWaitingAreaRooms)
  );
  const [maxWidthAllowedForParticipantRow, setMaxWidthAllowedForParticipantRow] = useState(100);
  const [showParticipants, setShowParticipants] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [waitingAreaRoomsGray, setWaitingAreaRoomsGray] = useState(props.waitingAreaRoomsGray);

  const [mouseY, setMouseY] = useState();

  const updateWaitingAreaSearchWithInComponent = (e) => {
    if (e.target != undefined) dispatch(updateWaitingAreaSearch(e.target.value));
    else dispatch(updateWaitingAreaSearch(e));
  };

  useLayoutEffect(() => {
    setWaitingAreaRoomsFiltered(props.waitingAreaRoomsFiltered.slice().sort(sortWaitingAreaRooms));
    setWaitingAreaRoomsGray(props.waitingAreaRoomsGray.slice().sort(sortWaitingAreaRooms));
  }, [props.waitingAreaRoomsFiltered, props.waitingAreaRoomsGray]);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.new-waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.new-waiting-area-view-one', event));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.new-waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.new-waiting-area-view-one', event));
    };
  }, []);

  const mouseMovedOnTable = (e) => {
    let heightOfOneRow = 0;
    if (window.$(e.target).hasClass('right-column-fixed')) {
      heightOfOneRow = window.$(e.target).height();
    }
    setMouseY(e.pageY - window.$(e.target).offset().top + heightOfOneRow);
  };

  const setContextMenuParticipants = (options) => {
    // Update the participants list in local state
    if (JSON.stringify(participants) != JSON.stringify(options)) {
      setParticipants(options);
    }
  };

  const getContextualMenu = (room, providerIsInCallWithSomeUser, answerCallPermission, callState) => {
    let participantsElm = '';
    if (room.participants.length > 0 && room.statusId !== APP.LANGUAGE.MessageCodes.StatusWaitingCode) {
      let finalOptions = room.participants.map((o, i) => {
        let personStatus = '';
        if (o.participantStatus == 'A') {
          if (o.canAnswerCall) {
            personStatus = APP.LANGUAGE.WaitingAreaPersonStatus.Provider;
          }
        }

        let textFinalParticipant = o.name + (personStatus != '' ? ` (${personStatus})` : '');
        return {
          style: {
            maxWidth: maxWidthAllowedForParticipantRow + '%',
          },
          text: textFinalParticipant,
          id: o.gcCallerId,
        };
      });
      // Update the participants list in local state if participant list is expanded already
      if (showParticipants) {
        setContextMenuParticipants(finalOptions);
      }
      // set the context menu
      participantsElm = (
        <Txt
          key={room.id}
          multiple={true}
          semanticui
          dropdown
          onClick={() => {
            setShowParticipants(!showParticipants);
            setContextMenuParticipants(finalOptions);
          }}
          open={showParticipants}
          text={APP.LANGUAGE.ViewOneWaitingArea.Participants}
          noIcon={true}
          className=" button labeled color-info max-width no-bold icon left-text normal participantsdropdown"
          options={participants}
        />
      );
    } else {
      participantsElm = (
        <div className="ui  max-width">
          <span className="text pdls">{APP.LANGUAGE.ViewOneWaitingArea.NoParticipantsMessage}</span>
        </div>
      );
    }

    let joinTitle = (
      <div>
        {room.statusId == APP.LANGUAGE.MessageCodes.StatusAttendedCode
          ? APP.LANGUAGE.ViewOneWaitingArea.JoinInProgressCallGC
          : APP.LANGUAGE.ViewOneWaitingArea.JoinIdleCallGC}
        <i className="ui icon sign in waiting-area-green fr" />
      </div>
    );

    let canJoinCall = !providerIsInCallWithSomeUser;

    return (
      <ContextualMenu
        id={room.id}
        options={
          room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode
            ? [
                {
                  title: (
                    <div style={{ width: '171px', overflowWrap: 'break-word' }}>
                      <i className="ui icon info circle" style={{ position: 'absolute', marginTop: '2px' }} />
                      <span style={{ paddingLeft: '22px' }}>
                        {htmlToReactParser.parse(
                          xss(
                            callState === ''
                              ? APP.LANGUAGE.ViewOneWaitingArea.StartAGCCallBySelectingStartCall
                              : callState === APP.LANGUAGE.MessageCodes.StatusAttendedCode
                              ? APP.LANGUAGE.ViewOneWaitingArea.AddWaitingCallerFromCallScreen
                              : APP.LANGUAGE.ViewOneWaitingArea.AddWaitingCallerFromCallScreenToIdleCall
                          )
                        )}
                      </span>
                    </div>
                  ),
                  customAction: false,
                  show: true,
                  fieldClass: '',
                },
              ]
            : [
                {
                  title: joinTitle,
                  customAction: true,
                  show: !room.isCurrentUserAnsweringThisCall && answerCallPermission,
                  action: () => {
                    if (!canJoinCall) {
                      return;
                    }
                    return props.handleJoinCallClick();
                  },
                  fieldClass: !canJoinCall ? 'disable-msg' : '',
                },
                {
                  title: <div> {APP.LANGUAGE.ViewOneWaitingArea.cannotJoinAction} </div>,
                  customAction: false,
                  show: !answerCallPermission,
                  fieldClass: 'disable-msg',
                },
                {
                  title: APP.LANGUAGE.ViewOneWaitingArea.CallerInConsultation,
                  customAction: false,
                  //if there are more than one participant
                  show: room.isCurrentUserAnsweringThisCall && room.participants.length > 0 && answerCallPermission,
                  fieldClass: 'disable-msg',
                },
                {
                  renderAsChild: true,
                  childComponent: participantsElm,
                },
              ]
        }
      />
    );
  };

  let peopleRows = '';
  let peopleGray = '';
  let inactiveMessage = '';

  let callStatus = (() => {
    let rooms = clone([...waitingAreaRoomsFiltered, ...waitingAreaRoomsGray]);
    if (rooms.length > 0) {
      let roomIdle = rooms.filter((room) => {
        return (
          room.statusId == APP.LANGUAGE.MessageCodes.StatusIdleCode ||
          room.statusId == APP.LANGUAGE.MessageCodes.StatusAttendedCode
        );
      });

      return roomIdle && roomIdle.length > 0 ? roomIdle[0].statusId : '';
    }

    return '';
  })();

  // If provider is in regular consultation
  let providerIsInCallWithSomeUser = isCurrentUserInCall || false;
  let answerCallPermission = props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1;

  let renderWaitingArea = (gray) => {
    let iterator = gray ? waitingAreaRoomsGray : waitingAreaRoomsFiltered;

    return iterator.map((room, i) => {
      let roomStatus =
        room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended
          ? APP.LANGUAGE.ViewOneWaitingArea.InProgress
          : room.mainParticipant.status;
      let minutes = getMinuteDiff(asOfNow, room.calculatedRoomWaitingFrom);
      return (
        <div
          className="row flexible row-hoverable "
          data-opaque={!!gray}
          key={room.id}
          onClick={(event) => {
            var trgt = event.target;
            var currentTrgt = event.currentTarget;
            let cb = () => {
              setTimeout(() => {
                showHideMenu(null, '.new-waiting-area-view-one', room.id, trgt, currentTrgt);
                setTimeout(() => {
                  let widthPlusLeft = $('.row').first().width(); //+ $('.row').first().position().left;
                  let contextualMenuStart = $('.contextual-menu-content').first().position().left;
                  setMaxWidthAllowedForParticipantRow(
                    widthPlusLeft - contextualMenuStart + maxWidthAllowedForParticipantRow
                  ); //1 compensates for left :1-px
                }, 0);
              }, 0);
            };
            dispatch(updateSelectedVideoCallRoomId(room.id, cb));
          }}
        >
          {props.selectedVideoCallRoomId == room.id
            ? getContextualMenu(room, providerIsInCallWithSomeUser, answerCallPermission, callStatus)
            : ''}
          <Container
            fluid
            as={Media}
            greaterThanOrEqual="tablet"
            className={
              props.calculateColor(room.mainParticipant.status, minutes) +
              ' left-column-fixed column status-column bold left-text inline-flex center-flex'
            }
            id="status-column"
            style={{ width: '25%' }}
          >
            <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
              {roomStatus}
            </div>
            {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
              ''
            ) : (
              <span className={props.calculateColor(room.mainParticipant.status, minutes)}>
                &nbsp;&#40;{minutes}&nbsp;
                {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                &#41;
              </span>
            )}
          </Container>
          <Container
            fluid
            as={Media}
            at="mobile"
            className={
              props.calculateColor(room.mainParticipant.status, minutes) +
              ' left-column-fixed column status-column bold left-text pdrnull flex-like center-flex'
            }
            id="status-column"
            style={{ width: '50%', fontSize: '0.94rem' }}
          >
            <div className="span-like left-text waiting-text" style={{ whiteSpace: 'nowrap' }}>
              {roomStatus}
            </div>
            {room.mainParticipant.status == APP.LANGUAGE.ViewOneWaitingArea.Attended ? (
              ''
            ) : (
              <span className={props.calculateColor(room.mainParticipant.status, minutes)}>
                &nbsp;&#40;{minutes}&nbsp;
                {APP.LANGUAGE.ViewOneWaitingArea.MinutesAbbreviation.toLowerCase()}
                &#41;
              </span>
            )}
          </Container>
          <Container
            fluid
            as={Media}
            greaterThanOrEqual="tablet"
            className="column pdlnull overflow-hidden inline-flex center-flex"
            style={{ width: '40%' }}
          >
            <Icon
              name="angle down"
              style={{ minWidth: '20px', marginTop: '-5px' }}
              className="mrrxs relative arrow-down-on-mobile"
            />
            {props.waitingArea.showDobField && room.dob ? (
              <span className="left-text caller-name">
                {room.mainParticipant.name}
                {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? (
                  ''
                ) : (
                  <React.Fragment>
                    <br />
                    {room.participants.length > 1
                      ? room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Callers
                      : room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Caller}
                  </React.Fragment>
                )}
                <div className="color-dob" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                  {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? getDOBFormat(room.dob) : ''}
                </div>
              </span>
            ) : (
              <span className="caller-name">
                {room.mainParticipant.name}
                {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? (
                  ''
                ) : (
                  <React.Fragment>
                    <br />
                    {room.participants.length > 1
                      ? room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Callers
                      : room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Caller}
                  </React.Fragment>
                )}
              </span>
            )}
          </Container>
          <Container
            fluid
            as={Media}
            greaterThanOrEqual="tablet"
            className="column pdlnull inline-flex center-flex"
            style={{ width: '35%' }}
          >
            <div className="caller-phone ellipsis">
              {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? room.mainParticipant.phone : ''}
            </div>
          </Container>
          <Container fluid as={Media} at="mobile" className="column pdlnull inline-flex" style={{ width: '50%' }}>
            <Icon name="angle down" className="mrrxs arrow-down-on-mobile" style={{ marginTop: '-5px' }} />
            <div className="caller-info-wrapper">
              <div className="caller-name">
                {room.mainParticipant.name}
                {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? (
                  ''
                ) : (
                  <React.Fragment>
                    <br />
                    {room.participants.length > 1
                      ? room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Callers
                      : room.participants.length + ' ' + APP.LANGUAGE.ViewOneWaitingArea.Caller}
                  </React.Fragment>
                )}
              </div>
              {props.waitingArea.showDobField &&
              room.dob &&
              room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? (
                <div className="color-dob caller-phone" style={{ fontSize: '0.92rem', fontWeight: '700' }}>
                  {getDOBFormat(room.dob)}
                </div>
              ) : (
                ''
              )}
              <div className="color-gray caller-phone ellipsis" style={{ fontSize: '0.92rem', textAlign: 'left' }}>
                {room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode ? room.mainParticipant.phone : ''}
              </div>
            </div>
          </Container>
        </div>
      );
    });
  };

  if (
    !props.fetchingWaitingArea ||
    props.waitingAreaRoomsFiltered.length > 0 ||
    props.waitingAreaRoomsGray.length > 0
  ) {
    peopleRows = renderWaitingArea(false);
    peopleGray = renderWaitingArea(true);
  } else {
    peopleRows = props.loadCallerRowTemplate();
  }

  if (!props.fetchingWaitingArea && !isGroupConsultationFeatureEnabled) {
    inactiveMessage = (
      <div className="color-right-hand-side-panel-bg max-width pdlnull pdrnull">
        <div className="row flexible row-hoverable center-text pointer color-right-hand-side-panel-bg">
          <Message icon className="borderless bg-transparent mrbnull pdlnull pdrnull pdts pdbs">
            <Message.Content>
              <div className="inline-flex center-flex">
                <Icon name="warning sign" size="big" className="waiting-area-red" style={{ marginRight: '10px' }} />
                <div className="text-size-m left-text">
                  <b>{APP.LANGUAGE.ViewOneWaitingArea.WaitingAreaInactive}</b>
                </div>
              </div>
            </Message.Content>
          </Message>
        </div>
      </div>
    );
  }

  let mainWAContent = (
    <span>
      <div onMouseMove={mouseMovedOnTable} className="ui center aligned padded grid">
        <Container
          fluid
          as={Media}
          greaterThanOrEqual="tablet"
          className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
        >
          <span
            className="ui transparent large fluid icon input color-white  hand waiting-areas-filter column display-flex"
            style={{ width: '25%' }}
          >
            <input
              className="color-white color-waiting-area-highlight max-width  pdxs "
              id="input-in-row"
              type="text"
              onChange={(e) => updateWaitingAreaSearchWithInComponent(e)}
              value={props.currentWaitingAreaFilter}
              placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
            />
            <i className="filter icon mrrml" />
          </span>
          <span
            className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
            style={{ width: '40%' }}
          >
            <div className="color-white max-width pdxs left-text ">
              {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
            </div>
          </span>
          <span
            className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex hide-on-small-ress pdlnull"
            style={{ width: '35%' }}
          >
            <div className="color-white max-width pdxs pdlnull left-text ">
              {APP.LANGUAGE.ViewOneWaitingArea.TelephonePlaceholder}
            </div>
          </span>
        </Container>
        <Container
          fluid
          as={Media}
          at="mobile"
          className="row flexible color-waiting-area-bg pdtnull pdbnull header-row pdlnull"
        >
          <span
            className="ui transparent large fluid icon input color-white  hand waiting-areas-filter column display-flex"
            style={{ width: '50%' }}
          >
            <input
              className="color-white color-waiting-area-highlight max-width  pdxs "
              id="input-in-row"
              type="text"
              onChange={(e) => updateWaitingAreaSearchWithInComponent(e)}
              value={props.currentWaitingAreaFilter}
              placeholder={APP.LANGUAGE.ViewOneWaitingArea.StatusPlaceholder}
            />
            <i className="filter icon mrrml" />
          </span>
          <span
            className="ui transparent large fluid icon input color-white waiting-areas-filter column display-flex"
            style={{ width: '50%' }}
          >
            <div className="color-white max-width pdxs left-text ">
              {APP.LANGUAGE.ViewOneWaitingArea.CallerPlaceholder}
            </div>
          </span>
        </Container>
        {inactiveMessage}
        {/* Will render No calls, Suspend/Resume rows */}
        <CenterPanelShared
          waitingArea={props.waitingArea}
          fetchingWaitingArea={props.fetchingWaitingArea}
          timezone={props.timezone}
          waitingAreaRoomsGray={props.waitingAreaRoomsGray}
          waitingAreaRoomsFiltered={props.waitingAreaRoomsFiltered}
          dispatch={dispatch}
          waitingAreaClosingMessageThresholdMinutes={waitingAreaClosingMessageThresholdMinutes}
        />
        {peopleRows}
        {peopleGray}
      </div>
    </span>
  );

  return mainWAContent;
}
